// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10jZW","rootMobile":"styles_rootMobile__2eSrl"};